// Classes.
import {ExtendedEventBaseItem} from '../types/extended-event-base.item';
// Services.
import {WaHelperService} from '../../wa-services/wa-helper-service';
export class EventGeneralInfoItem extends ExtendedEventBaseItem {
  public place: string;
  public isLive: boolean;
  public results: boolean;
  public isWRE: boolean;
  public isPWRE: boolean;
  public statusId:number;
  constructor(rawEventGeneralInfoItem: any, protected waHelperService: WaHelperService) {
    super(rawEventGeneralInfoItem, waHelperService);
    // Process proprerties only in EventGeneralInfoItem.
    this.place = rawEventGeneralInfoItem.Place;
    this.isLive = rawEventGeneralInfoItem.IsLive;
    this.results = rawEventGeneralInfoItem.WithRes;
    this.isWRE =  false;
    this.isPWRE = false;
    if (Array.isArray(rawEventGeneralInfoItem.Options)) {
      this.isWRE = rawEventGeneralInfoItem.Options.indexOf('WRE') !== -1;
      this.isPWRE = rawEventGeneralInfoItem.Options.indexOf('PWRE') !== -1;
    }
  }
}
